import { render, staticRenderFns } from "./PelletsArticle.vue?vue&type=template&id=5cb743a6&scoped=true"
import script from "./PelletsArticle.vue?vue&type=script&lang=ts"
export * from "./PelletsArticle.vue?vue&type=script&lang=ts"
import style0 from "./PelletsArticle.vue?vue&type=style&index=0&id=5cb743a6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb743a6",
  null
  
)

export default component.exports